import { render, staticRenderFns } from "./AppSidebarHandle.vue?vue&type=template&id=38622948&"
import script from "./AppSidebarHandle.vue?vue&type=script&lang=js&"
export * from "./AppSidebarHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports